export const PAYEE_CATALOG_TYPE_DEFAULT = "DEFAULT"
export const PAYEE_CATALOG_TYPE_EVENT = "EVENT"
export const PAYEE_CATALOG_TYPE_ORDERING = "ORDERING"
export const PAYEE_CATALOG_TYPE_BOOKING = "BOOKING"
export const PAYEE_CATALOG_TYPE_SCHEDULING = "SCHEDULING"
export const PAYEE_CATALOG_TYPE_DELIVERY = "DELIVERY"
export const PAYEE_CATALOG_DEFAULT_CATEGORY_ID = "PAYEE_CATALOG_DEFAULT_CATEGORY_ID"

export const PAYEE_CATALOG_TYPE_DELIVERY_API_RESPONSE_CODES = {
    INVALID_INPUT: "INVALID_INPUT",
    NOT_FOUND: "NOT_FOUND",
    INVALID_TYPE: "INVALID_TYPE",
    INACTIVE: "INACTIVE",
    CLOSED: "CLOSED",
    OUT_OF_PICKUP_RANGE: "OUT_OF_PICKUP_RANGE",
    OUT_OF_DELIVERY_RANGE: "OUT_OF_DELIVERY_RANGE"
}

export const DEFAULT_PREP_TIMES = {
    avg: "00:20",
    buffer: "00:10",
    max: "01:00",
};

export const DEFAULT_PAYEE_DAILY_OPENING_HOURS = {openingTime: "08:00", closingTime: "16:00"}
export const DEFAULT_PAYEE_OPENING_HOURS = {
  monday: DEFAULT_PAYEE_DAILY_OPENING_HOURS,
  tuesday: DEFAULT_PAYEE_DAILY_OPENING_HOURS,
  wednesday: DEFAULT_PAYEE_DAILY_OPENING_HOURS,
  thursday: DEFAULT_PAYEE_DAILY_OPENING_HOURS,
  friday: DEFAULT_PAYEE_DAILY_OPENING_HOURS,
  saturday: DEFAULT_PAYEE_DAILY_OPENING_HOURS,
}